/**
 * Wrapper visual reutilizable para las "cajas" de la pantalla de reparación.
 * DS v2 — bordes redondeados sutiles, header con degradado, sombra suave.
 * Preserva la API pública: `title`, `testid`, `children`.
 */
export default function Box({ title, testid, children, right }) {
  return (
    <div className="ds-card" data-testid={testid}>
      <div className="ds-card-h">
        <div className="t">{title}</div>
        {right}
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
}
